// Таблица повторяет appScreen.ts бэкенда (modules/admin/banner): она нужна,
// чтобы показать экран сразу при вводе ссылки, до сохранения баннера.
// Итоговое значение всё равно считает бэкенд.
const APP_HOSTS = ['horsesmart.store', 'rus-polo.ru']

const ENTITY_SCREENS: Record<string, { screen: string; param: string }> = {
  product: { screen: 'Product', param: 'productSlug' },
  seller: { screen: 'Seller', param: 'sellerSlug' },
  collection: { screen: 'Collection', param: 'collectionSlug' },
  service: { screen: 'Service', param: 'serviceSlug' },
  services: { screen: 'Service', param: 'serviceSlug' },
  horse: { screen: 'HorseDetails', param: 'horseSlug' },
  category: { screen: 'SubCategoryProducts', param: 'subCategorySlug' }
}

const SECTION_SCREENS: Record<string, string> = {
  services: 'Services',
  horses: 'Horse',
  cart: 'Cart',
  ruspoloclub: 'PoloClub'
}

interface IAppScreen {
  navigation_path: string
  navigation_params: Record<string, string> | null
}

const getPathSegments = (rawUrl: string): string[] | null => {
  const value = rawUrl.trim()
  if (!value) return null
  let pathname = value
  if (/^https?:\/\//i.test(value)) {
    try {
      const url = new URL(value)
      if (!APP_HOSTS.includes(url.hostname.replace(/^www\./, ''))) return null
      if (url.hostname.replace(/^www\./, '') === 'rus-polo.ru' && url.pathname === '/') return ['ruspoloclub']
      pathname = url.pathname
    } catch {
      return null
    }
  }
  return pathname.split(/[?#]/)[0].split('/').filter(Boolean)
}

export const getAppScreenFromUrl = (rawUrl?: string | null): IAppScreen | null => {
  const segments = rawUrl ? getPathSegments(rawUrl) : null
  if (!segments?.length) return null

  const [section, slug] = segments
  if (segments.length === 1) {
    const screen = SECTION_SCREENS[section]
    return screen ? { navigation_path: screen, navigation_params: null } : null
  }
  // адреса глубже двух сегментов (например фильтр категории) экрана не имеют
  const entity = segments.length === 2 ? ENTITY_SCREENS[section] : undefined
  if (!entity) return null
  return {
    navigation_path: entity.screen,
    navigation_params: { [entity.param]: slug }
  }
}

export const formatAppScreen = (
  navigation_path?: string | null,
  navigation_params?: Record<string, any> | null
): string => {
  if (!navigation_path) return ''
  if (!navigation_params) return navigation_path
  const params = Object.entries(navigation_params)
    .map(([key, value]) => `${key}: ${value}`)
    .join(', ')
  return params ? `${navigation_path} (${params})` : navigation_path
}
